/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import DocumentData from '../utils/Interface/DocumentData';
import { MDBBadge, MDBTable, MDBTableHead, MDBTableBody, MDBCheckbox, MDBPagination, MDBPaginationItem, MDBPaginationLink } from 'mdb-react-ui-kit';
import "../style/css/tablecomplexe.css";


interface Props {
  documents: DocumentData[];
  textaction: string;
  onEdit: (id: number, name: string) => void;
  Present: number; // Fonction pour gérer l'édition
  onLignClick: (user_id: number) => void;
  response: boolean;
}

const TableComplexeDocument: React.FC<Props> = ({ documents, textaction, onEdit, Present, onLignClick, response }) => {

  const [currentPage, setCurrentPage] = useState(1);
  const documentsPerPage = 10;
  const totalPages = Math.ceil(documents.length / documentsPerPage);
  const indexOfLastDocument = currentPage * documentsPerPage;
  const indexOfFirstDocument = indexOfLastDocument - documentsPerPage;
  const currentDocuments = documents.slice(indexOfFirstDocument, indexOfLastDocument);
  const [relocation, setRelocation] = useState(response);

  const handleEdit = (id: number, name: string) => {
    onEdit(id, name);
  };

  const handleLignClick = (user_id: number) => {
    if (relocation){
    onLignClick(user_id);
    window.location.href = `/inventaire/utilisateurs/${user_id}`;} else {
      return
    }
  };

  const handlePageChange = (pageNumber: number) => {
    if (pageNumber < 1) {
      setCurrentPage(1); // Ne pas descendre en dessous de la première page
    } else if (pageNumber > totalPages) {
      setCurrentPage(totalPages); // Ne pas aller au-delà de la dernière page
    } else {
      setCurrentPage(pageNumber); // Mettre à jour la page actuelle
    }
  };

  type BadgeColor = 'success' | 'warning' | 'danger';

  const getBadgeColorAndText = (state: string | null): { color: BadgeColor; text: string } => {
    if (state === null || state === 'Signé') {
      return { color: 'success', text: 'Signé' };
    } else if (state === 'envoyé') {
      return { color: 'danger', text: 'En attente de signature' };
    } else {
      return { color: 'warning', text: 'Créé' };
    }
  };

  return (
    <div className='tablecomplexe'>

      <MDBTable align='middle' className='tablecomplexe__table'>

        <MDBTableHead>

          <tr className='tablecomplexe__table__categories'>

            <th scope='col' className={`checkbockpresent${Present}`}> 
              
              {/* 0 present 1 absent */}

              <MDBCheckbox></MDBCheckbox>

            </th>

            <th scope='col' className='fw-bold mb-1'>Utilisateur</th>

            <th scope='col' className='fw-bold mb-1'>Etat</th>
            

            <th scope='col' id="tablecomplexeremove" className='fw-bold mb-1'>Modèle de document</th>

            <th scope='col' id="tablecomplexeremove"  className='fw-bold mb-1'>Nom de document</th>

            <th scope='col' className='fw-bold mb-1'>Actions</th>

          </tr>

        </MDBTableHead>

        <MDBTableBody>

          {currentDocuments.map((doc, index) => (

            <tr key={index} className='tablecomplexe__table__items'>

              <td className={`checkbockpresent${Present}`}>

                <MDBCheckbox></MDBCheckbox>

              </td>

              <td onClick={() => handleLignClick (doc.user_id)}>

                <div className='d-flex align-items-center'>

                  <div className='ms-3'>

                    <p className='fw-bold mb-1'>{doc.user_name}</p>

                    <p className='text-muted mb-0'>{doc.user_email}</p>

                  </div>

                </div>

              </td>

              <td onClick={() => handleLignClick (doc.user_id)}>

                <MDBBadge 
                color={getBadgeColorAndText(doc.document_state).color}
                pill>

                  {getBadgeColorAndText(doc.document_state).text}
                </MDBBadge>

              </td>
              

              <td id="tablecomplexeremove" onClick={() => handleLignClick (doc.user_id)}>{doc.documents_modeles_name}</td>

              <td id="tablecomplexeremove"onClick={() => handleLignClick (doc.user_id)} >{doc.document_name}</td>

              <td className='edit'>

                <button
                  type="button"
                  onClick={() => handleEdit(doc.document_id, doc.document_name)}
                  className="btn btn-link btn-sm btn-rounded"
                  id="btntable"
                >
                  {textaction}

                </button>

              </td>

            </tr>

          ))}

        </MDBTableBody>

      </MDBTable>

      {totalPages > 1 && (

        <nav aria-label='Page navigation'>

          <MDBPagination circle className='mb-0'>
            
            <MDBPaginationItem disabled={currentPage === 1}>

              <MDBPaginationLink onClick={() => handlePageChange(currentPage - 1)} tabIndex={-1} aria-disabled={currentPage === 1}>

                <p className='page'>Page précédente</p>

              </MDBPaginationLink>

            </MDBPaginationItem>

            <MDBPaginationItem disabled={currentPage === 1}>

              <MDBPaginationLink onClick={() => handlePageChange(1)} tabIndex={-1} aria-disabled={currentPage === 1}>
                <p className='page' id='number'>1</p>
              </MDBPaginationLink>

            </MDBPaginationItem>

            {currentPage !== 1 && (

              <MDBPaginationItem>

                <MDBPaginationLink>

                  <p className='page' id='number'>{currentPage}</p>

                </MDBPaginationLink>

              </MDBPaginationItem>
            )}

            <MDBPaginationItem disabled={currentPage === totalPages}>

              <MDBPaginationLink onClick={() => handlePageChange(totalPages)}>

                <p className='page' id='number'>{totalPages}</p>

              </MDBPaginationLink>

            </MDBPaginationItem>

            <MDBPaginationItem disabled={currentPage === totalPages}>

              <MDBPaginationLink onClick={() => handlePageChange(currentPage + 1)} aria-disabled={currentPage === totalPages}>

                <p className='page'>Page suivante</p>

              </MDBPaginationLink>

            </MDBPaginationItem>

          </MDBPagination>

        </nav>
      )}

    </div>
  );
}

export default TableComplexeDocument;
